import { Component, input } from '@angular/core';
import { provideIcons } from '@ng-icons/core';
import { heroChevronRightMini } from '@ng-icons/heroicons/mini';
import { IconComponent } from 'app/shared/icon/icon.component';

@Component({
  selector: 'app-menu-item',
  standalone: true,
  imports: [IconComponent],
  templateUrl: './menu-item.component.html',
  styles: ``,
  host: {
    class: 'flex justify-between min-w-[220px] gap-2',
  },
  providers: [provideIcons({ heroChevronRightMini })],
})
export class MenuItemComponent {
  iconName = input.required<string>();
}
